module.exports = __webpack_public_path__ + "static/header-background-ef110abb36e9ee334ef1708eba464846.jpg";